<template>
  <div style="margin-bottom:1.5rem">
    <!-- 가격 정보 -->
    <div class="box">
      <admin-box-item title="가격 정보" :disabled="disabled">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="판매가격 사용여부">
              <lp-radio :val.sync="prod_price.price_type"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:0}, {label:'대체문구 사용', value:1}]"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="prod_price.price_type === 1">
            <admin-form-item label="판매가격 대체문구">
              <span class="select">
                <select v-model="selected_alt_text.value" @change="selectAltText">
                  <option :value="text.value" v-for="(text, text_idx) in alt_text_arr" :key="`alt_text-${text_idx}`">
                    {{ text.label }}</option>
                </select>
                <!--<select v-model="prod_price.price_text" @change="e => prod_price.price_text=e.target.value">
                  <option value="관리자에게 문의">관리자에게 문의</option>
                  <option value="파트너에게 문의">파트너에게 문의</option>
                  <option value="회원 전용가">회원 전용가</option>
                  <option value="이벤트가">이벤트가</option>
                  <option value="가격문의">가격문의</option>
                </select>-->
              </span>
              <input class="input"
                     style="margin-top:8px"
                     :value="prod_price.price_text"
                     @input="e => prod_price.price_text = e.target.value"
                     type="text" v-if="selected_alt_text.value===6">
              <!--<button class="button is-primary is-bordered" style="margin-left:8px">설정</button>-->
            </admin-form-item>
          </div>
          <div class="column is-7" v-if="prod_price.price_type === 0">
            <admin-form-item label="판매가격">
              <div class="flex">
                <input class="input full has-text-right"
                       v-model="prod_price.price"
                       @input="e => setNumber(e, 'prod_price', 'price', 9)"
                       type="number" maxlength="10">
                <label class="label" style="margin: 4px 0px 0px 12px;">원</label>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="isAdmin">
            <admin-form-item label="원화 표시">
              <lp-radio :val.sync="prod_price.won_type"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'원',value:0},{label:'원~',value:1}]"></lp-radio>
            </admin-form-item>
          </div>
          <!--<div class="column is-5" v-if="prod_price.price_type === 0">
            <admin-form-item label="판매가격 기준단위">
              <div class="flex align-center">
                <div style="margin: 0 10px; padding-bottom:4px; color:#555555">{{ prod_price.unit }}</div>
                <button class="button is-primary is-bordered">설정</button>
              </div>
            </admin-form-item>
          </div>-->

          <div class="column is-full">
            <admin-form-item label="판매 기간" tip="판매 기간을 설정하지 않을 경우, 무한대로 설정됩니다.">
              <div class="flex" style="flex-wrap:wrap">
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.start_date"
                    @setDate="date => selDateMin(date, 'price')"></admin-date-picker>
                </div>
                <div class="lp-dating">&#126;</div>
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.end_date"
                    @setDate="date => selDateMax(date, 'price')"></admin-date-picker>
                </div>
              </div>
            </admin-form-item>
            <div v-if="errorTime" style="font-size: 0.8rem;color: #db2828;">시작 시간/종료 시간 범위 설정이 잘못되었습니다.</div>
          </div>

          <div class="column is-full" v-if="sale_remain > 0">
            <admin-form-item label="남은 판매 가능 시간">
              {{ remainTime(sale_remain) }}
            </admin-form-item>
          </div>


          <div class="column is-full" v-if="dailyEnable">
            <admin-form-item label="종일 패키지 사용여부">
              <lp-radio :val.sync="prod_price.all_time"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-7" v-if="prod_price.all_time && dailyEnable">
            <admin-form-item label="종일 패키지 가격">
              <div class="flex">
                <input class="input full has-text-right"
                       v-model="prod_price.all_time_price"
                       @input="e => setNumber(e, 'prod_price', 'all_time_price', 8)"
                       type="number" maxlength="10">
                <label class="label" style="margin: 4px 0px 0px 12px;">원</label>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="prod_price.all_time && dailyEnable">
            <admin-form-item label="판매 기간">
              <div class="flex" style="flex-wrap:wrap">
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.all_time_start"
                    @setDate="date => selDateMin(date, 'all_time')"></admin-date-picker>
                </div>
                <div class="lp-dating">&#126;</div>
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.all_time_end"
                    @setDate="date => selDateMax(date, 'all_time')"></admin-date-picker>
                </div>
              </div>
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>

    <!-- 할인 가격 설정 -->
    <div class="box" v-if="enablePanel('panel4')">
      <admin-box-item :title="panel.discount.title" :disabled="disabled" :showToggleButton="true">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item :label="panel.discount.enable_discount_label">
              <lp-radio :val.sync="prod_price.is_discount"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
            </admin-form-item>
          </div>
          <div v-if="prod_price.is_discount">
            <div class="column is-full">
              <admin-form-item :label="panel.discount.discount_type_label">
                <lp-radio :val.sync="prod_price.discount_type"
                          value_name="value"
                          label_name="label"
                          @update:val="$emit('calcPrice')"
                          :showInput="true"
                          :block="true"
                          @onEdit="onEditDiscount"
                          :data="[{label:'할인율', value:0, num: prod_price.discount_rate, unit:'%'},
                                      {label:'금액 할인', value:1, num: prod_price.discount_price, unit:'원'}]"></lp-radio>
              </admin-form-item>
            </div>
            <div class="column is-full" v-if="isTimeSale && time_sale_remain > 0">
              <admin-form-item label="타임 세일 남은 기간">
                {{ remainTime(time_sale_remain) }}
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item :label="panel.discount.discount_label">
                <label class="label"
                       style="padding-left: 4px;">
                  {{ prod_price.saleDiscount | currency }}
                </label>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="할인 기간">
                <lp-radio :val.sync="prod_price.discount_period_type" style="margin-bottom: 12px"
                          value_name="value"
                          label_name="label"
                          :data="discountPeriodTypeArr"></lp-radio>

                <!-- 날짜별 할인 -->
                <div class="flex" style="flex-wrap:wrap" v-if="!prod_price.discount_period_type">
                  <div style="align-items: center;">
                    <admin-date-picker
                      type="datetime"
                      :data="prod_price.discount_start"
                      @setDate="date => selDateMin(date, 'discount')"></admin-date-picker>
                  </div>
                  <div class="lp-dating">&#126;</div>
                  <div style="align-items: center;">
                    <admin-date-picker
                      type="datetime"
                      :data="prod_price.discount_end"
                      @setDate="date => selDateMax(date, 'discount')"></admin-date-picker>
                  </div>
                </div>
                <!-- 시간대별 할인 -->
                <div v-else class="list-schedule-time">
                  <div v-for="(item,idx) in scheduleTimes" :key="'schdule-'+idx"
                       :style="scheduleItemStyle(item)" class="item-schedule-time unselect"
                       @click="clickScheduleItem(item)">{{ `${item.start_time}~${item.end_time}` }}
                  </div>
                </div>
                <div v-if="errorDiscountTime" style="font-size: 0.8rem;color: #db2828;">시작 시간/종료 시간 범위 설정이 잘못되었습니다.</div>
              </admin-form-item>
            </div>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import ProductPanelMixin from "@/mixins/ProductPanelMixin";
  import moment from 'moment';
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    name: "PanelProductPrice",
    components: {LpRadio},
    mixins: [
      ProductPanelMixin
    ],
    props: {
      prod: {
        type: Object
      },
      prod_price: {
        type: Object
      },
      panel: {
        type: Object
      },
      disabled: {
        type: Boolean
      }
    },
    data() {
      return {
        alt_text_arr: [
          { label: '관리자에게 문의', value: 1 },
          { label: '파트너에게 문의', value: 2 },
          { label: '회원 전용가', value: 3 },
          { label: '이벤트가', value: 4 },
          { label: '가격문의', value: 5 },
          { label: '직접입력', value: 6 }
        ],
        // 대체텍스트 문구
        selected_alt_text: {
          label: '',
          value: 0
        },
        // 판매
        sale_interval: undefined,
        sale_remain: 0,
        // 타임 세일
        time_sale_interval: undefined,
        time_sale_remain: 0,
        scheduleTimes: [
          {
            start_time: '10:00',
            end_time: '12:00'
          },
          {
            start_time: '12:00',
            end_time: '14:00'
          }
        ],
        // 종일 패키지 사용 여부
        dailyEnable: false
      }
    },
    destroyed() {
      // 페이지 빠저 나갈 시 인터벌 제거
      clearInterval(this.time_sale_interval);
      clearInterval(this.sale_interval);
    },
    created() {
      this.scheduleTimes = this.$store.getters.scheduleTimes;
    },
    computed: {
      discountPeriodTypeArr() {
        let result = [];
        if(this.prod.package==='reservation') {
          result = [{label:'날짜별 할인',value:false}, {label:'시간대별 할인', value:true}];
        }
        else {
          result = [{label:'날짜별 할인',value:false}];
        }
        return result;
      },
      errorTime() {
        let start_date = this.prod_price.start_date;
        let end_date = this.prod_price.end_date;
        if (start_date && end_date) {
          let is_before = moment(start_date).isBefore(end_date);
          return !is_before;
        }
      },
      errorDiscountTime () {
        let start_date = this.prod_price.discount_start;
        let end_date = this.prod_price.discount_end;
        if (start_date && end_date) {
          let is_before = moment(start_date).isBefore(end_date);
          return !is_before;
        }
      }
    },
    watch: {
      '$store.getters.scheduleTimes'(n) {
        this.scheduleTimes = n;
      },
      '$store.getters.dailyEnable'(n) {
        this.dailyEnable = n;
      },
      prod_price: {
        handler (n) {
          // 대체 텍스트 사용할 경우
          if(this.prod_price.price_type===1 && this.prod_price.price_text) {
            let data = find(this.alt_text_arr, 'label', this.prod_price.price_text);
            if(data) {
              this.selected_alt_text = {
                label: data.label,
                value: data.value
              }
            }
            else {
              this.selected_alt_text = {
                label: '직접입력',
                value: 6
              }
            }
          }
        },
        deep: true
      }
    },
    methods: {
      selectAltText(e) {
        let val = parseInt(e.target.value);
        // 직접 입력일 경우 예외처리
        if(val===6) {
          this.prod_price.price_text = '';
        }
        else {
          this.prod_price.price_text = find(this.alt_text_arr, 'value', val).label;
        }
      },
      getRemains() {
        if (this.prod_price.start_date && this.prod_price.end_date) {
          this.sale_interval = setInterval(this.calculateSaleRemain, 1000);
        }
        if (this.prod_price.discount_start && this.prod_price.discount_end) {
          if (this.isInternalPlugin('time_sale'))
            this.time_sale_interval = setInterval(this.calculateTimeSaleRemain, 1000);
        }
      },
      // 타임 세일 남는 시간
      calculateTimeSaleRemain() {
        // 세일 전 일경우
        if (moment(this.prod_price.discount_start).isBefore(moment())) {
          //this.time_sale_remain = moment(this.prod_price.discount_end).diff(moment(), 'seconds');
          this.time_sale_remain = 0;
        }
        // 세일 후
        else if (moment(this.prod_price.discount_start).isAfter(moment())) {
          this.time_sale_remain = moment(this.prod_price.discount_end).diff(moment(this.prod_price.discount_start), 'seconds');
        }
        if (moment(this.prod_price.discount_end).isBefore(moment())) {
          clearInterval(this.time_sale_interval);
        }
      },
      // 남는 시간 계산
      calculateSaleRemain() {
        // 세일 전
        if (moment(this.prod_price.start_date).isBefore(moment())) {
          // this.sale_remain = moment(this.prod_price.end_date).diff(moment(), 'seconds');
          this.sale_remain = 0;
        } else if (moment(this.prod_price.start_date).isAfter(moment())) {
          this.sale_remain = moment(this.prod_price.end_date).diff(moment(this.prod_price.start_date), 'seconds');
        }
        if (moment(this.prod_price.end_date).isBefore(moment())) {
          clearInterval(this.sale_interval);
        }
      },
      // 남은 시간 리턴
      remainTime(remain) {
        let seconds = moment.duration(remain, 'seconds');
        return `${seconds.days()}일 ${seconds.hours()}시간 ${seconds.minutes()}분 ${seconds.seconds()}초`
      },
      selDateMin(date, type) {
        if (type === 'price') this.prod_price.start_date = date;
        else if (type === 'discount') this.prod_price.discount_start = date;
        else if (type === 'all_time') this.prod_price.all_time_start = date;
      },
      selDateMax(date, type) {
        if (type === 'price') this.prod_price.end_date = date;
        else if (type === 'discount') this.prod_price.discount_end = date;
        else if (type === 'all_time') this.prod_price.all_time_end = date;
      },
      onEditDiscount(res) {
        if (res.text === '' || res.text === 0) res.text = 0;
        if (res.value === 0) {
          this.prod_price.discount_rate = parseFloat(res.text);
        } else {
          this.prod_price.discount_price = parseInt(res.text);
        }

        // 할인
        if (this.prod_price.discount_type === 0)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - (this.prod_price.price * parseFloat(this.prod_price.discount_rate) / 100);
        else if (this.prod_price.discount_type === 1)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);
      },
      // 타임 세일인지 확인
      isTimeSale() {
        if (this.isInternalPlugin('time_sale')) {
          this.addDiscountPanel();
          return true;
        } else {
          return false;
        }
      },
      addDiscountPanel() {
        this.panel.discount = {
          title: '타임 세일 사용 여부',
          enable_discount_label: '타임 세일 사용여부',
          discount_type_label: '할인 방법',
          discount_label: '할인 후 가격'
        }
      },
      scheduleItemStyle(item) {
        let deco = {
          padding: '4px 8px',
          color: '#bbb',
          textAlign: 'center',
          fontSize: '12px'
        };
        this.prod_price.discount_time.forEach(time => {
          if (item.start_time === time.start_time && item.end_time && time.end_time) {
            deco.color = '#ff5722';
            deco.fontWeight = '600';
          }
        });

        return deco;
      },
      clickScheduleItem(item) {
        let times = this.prod_price.discount_time;

        let exists = times.filter(time => {
          return item.start_time === time.start_time && item.end_time && time.end_time;
        }).length;
        // 추가된 시간대가 없을 경우 추가
        if (exists === 0) {
          times.push(item);
        } else {
          // 기존에 있을 경우 삭제
          for (let i = 0; i < times.length; i++) {
            let time = times[i];
            if (item.start_time === time.start_time && item.end_time && time.end_time) {
              removeIndex(times, i);
            }
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .list-schedule-time
    display flex
    text-align center
    width 100%
    flex-wrap wrap

  .item-schedule-time
    width calc(33.3333% - 4px)
    border 1px solid #dddddd
    margin 2px

  .item-schedule-time:hover
    background-color #f9f9f9

</style>
